import React from 'react';
import {TrophyIcon} from '@heroicons/react/24/outline';

/**
 * Shows the deterministic max-error bonus winner(s): the Elite
 * forecaster(s) with the lowest peak error. Derived from the merged
 * payment rows (league_bonus_payment_det, summed across horizons by
 * the backend). Hidden on the probabilistic metric view (the bonus is
 * deterministic-only) and when no bonus was paid.
 */
export default function MaxErrorBonusBadge({payments = [], blurSensitive = false, metric = 'total', horizonCategory = 'all'}) {
  if (metric === 'probabilistic') return null;
  const winners = payments.filter(p => (p.league_bonus_payment_det ?? 0) > 0);
  if (winners.length === 0) return null;
  const amount = winners.reduce((s, w) => s + w.league_bonus_payment_det, 0);
  let suffix = '';
  if (winners.length > 1) {
    // In the default all-horizons view, league_bonus_payment_det is summed
    // across envelopes, so multiple winners are not necessarily a tie:
    // they may each have won a different per-envelope bonus.
    suffix = horizonCategory !== 'all' ? ' (tied, split equally)' : ' (across envelopes)';
  }
  return (
    <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 text-sm">
      <TrophyIcon className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" />
      <span className="text-amber-800 dark:text-amber-200">
        Lowest peak error:{' '}
        <span className="font-medium">
          {blurSensitive ? '***' : winners.map(w => w.email).join(', ')}
        </span>{' '}
        <span className="font-semibold">+€{amount.toFixed(2)}</span>
        {suffix}
      </span>
    </div>
  );
}
